import Enum from '../interfaces/IEnum';

export const ReplacementReasonsNumbers: Enum = {
    translations: {
        0: {
            0: 'lang.reasons.rejectOffer',
            1: 'lang.reasons.notPresentSign',
            2: 'lang.reasons.notMeetRequirements',
            3: 'lang.reasons.disciplinaryFile',
            4: 'lang.reasons.notPassTrialPeriod',
            5: 'lang.filter.unreachable',
            6: 'lang.reasons.criminalRecord',
            7: 'lang.reasons.disclaimerParticipateBag',
            8: 'lang.reasons.voluntaryCessation'
        },
        200: {
            200: 'lang.reasons.unemploymentPublic',
            201: 'lang.reasons.childCustody',
            202: 'lang.reasons.genderViolence',
            203: 'lang.reasons.longtermIllness',
            204: 'lang.reasons.maternity',
            205: 'lang.reasons.dependentPerson',
            206: 'lang.reasons.marriage',
            207: 'lang.filter.working',
            208: 'lang.reasons.studies',
            209: 'lang.reasons.classroomCourse',
            210: 'lang.reasons.changeResidence',
            211: 'lang.reasons.seriousIllness',
            212: 'lang.reasons.inexcusableDuty',
            213: 'lang.reasons.deathFamily',
            214: 'lang.reasons.pendingJustification'
        }
    },
    enum: {
        0: {
            REJECTOFFER: 0,
            NOTPRESENTSIGN: 1,
            NOTMEETREQUIREMENTS: 2,
            DISCIPLINARYFILE: 3,
            NOTPASSTRIALPERIOD: 4,
            UNREACHABLE: 5,
            CRIMINALRECORD: 6,
            DISCLAIMERPARTICIPATEBAG: 7,
            VOLUNTARYCESSATION: 8
        },
        200: {
            UNEMPLOYMENTPUBLIC: 200,
            CHILDCUSTODY: 201,
            GENDERVIOLENCE: 202,
            LONGTERMILLNESS: 203,
            MATERNITY: 204,
            DEPENDENTPERSON: 205,
            MARRIAGE: 206,
            WORKING: 207,
            STUDIES: 208,
            CLASSROOMCOURSE: 209,
            CHANGERESIDENCE: 210,
            SERIOUSILLNESS: 211,
            INEXCUSABLEDUTY: 212,
            DEATHFAMILY: 213,
            PENDINGJUSTIFICATION: 214
        }
    }
};

export const ReplacementReasons: Enum = {
    translations: {
        0: {
            'lang.reasons.rejectOffer': 'lang.reasons.rejectOffer',
            'lang.reasons.notPresentSign': 'lang.reasons.notPresentSign',
            'lang.reasons.notMeetRequirements': 'lang.reasons.notMeetRequirements',
            'lang.reasons.disciplinaryFile': 'lang.reasons.disciplinaryFile',
            'lang.reasons.notPassTrialPeriod': 'lang.reasons.notPassTrialPeriod',
            'lang.filter.unreachable': 'lang.filter.unreachable',
            'lang.reasons.criminalRecord': 'lang.reasons.criminalRecord',
            'lang.reasons.disclaimerParticipateBag': 'lang.reasons.disclaimerParticipateBag',
            'lang.reasons.voluntaryCessation': 'lang.reasons.voluntaryCessation'
        },
        200: {
            'lang.reasons.unemploymentPublic': 'lang.reasons.unemploymentPublic',
            'lang.reasons.childCustody': 'lang.reasons.childCustody',
            'lang.reasons.genderViolence': 'lang.reasons.genderViolence',
            'lang.reasons.longtermIllness': 'lang.reasons.longtermIllness',
            'lang.reasons.maternity': 'lang.reasons.maternity',
            'lang.reasons.dependentPerson': 'lang.reasons.dependentPerson',
            'lang.reasons.marriage': 'lang.reasons.marriage',
            'lang.filter.working': 'lang.filter.working',
            'lang.reasons.studies': 'lang.reasons.studies',
            'lang.reasons.classroomCourse': 'lang.reasons.classroomCourse',
            'lang.reasons.changeResidence': 'lang.reasons.changeResidence',
            'lang.reasons.seriousIllness': 'lang.reasons.seriousIllness',
            'lang.reasons.inexcusableDuty': 'lang.reasons.inexcusableDuty',
            'lang.reasons.deathFamily': 'lang.reasons.deathFamily',
            'lang.reasons.pendingJustification': 'lang.reasons.pendingJustification'
        }
    },
    enum: {
        0: {
            REJECTOFFER: 'lang.reasons.rejectOffer',
            NOTPRESENTSIGN: 'lang.reasons.notPresentSign',
            NOTMEETREQUIREMENTS: 'lang.reasons.notMeetRequirements',
            DISCIPLINARYFILE: 'lang.reasons.disciplinaryFile',
            NOTPASSTRIALPERIOD: 'lang.reasons.notPassTrialPeriod',
            UNREACHABLE: 'lang.filter.unreachable',
            CRIMINALRECORD: 'lang.reasons.criminalRecord',
            DISCLAIMERPARTICIPATEBAG: 'lang.reasons.disclaimerParticipateBag',
            VOLUNTARYCESSATION: 'lang.reasons.voluntaryCessation'
        },
        200: {
            UNEMPLOYMENTPUBLIC: 'lang.reasons.unemploymentPublic',
            CHILDCUSTODY: 'lang.reasons.childCustody',
            GENDERVIOLENCE: 'lang.reasons.genderViolence',
            LONGTERMILLNESS: 'lang.reasons.longtermIllness',
            MATERNITY: 'lang.reasons.maternity',
            DEPENDENTPERSON: 'lang.reasons.dependentPerson',
            MARRIAGE: 'lang.reasons.marriage',
            WORKING: 'lang.filter.working',
            STUDIES: 'lang.reasons.studies',
            CLASSROOMCOURSE: 'lang.reasons.classroomCourse',
            CHANGERESIDENCE: 'lang.reasons.changeResidence',
            SERIOUSILLNESS: 'lang.reasons.seriousIllness',
            INEXCUSABLEDUTY: 'lang.reasons.inexcusableDuty',
            DEATHFAMILY: 'lang.reasons.deathFamily',
            PENDINGJUSTIFICATION: 'lang.reasons.pendingJustification'
        }
    }
};
